export default __webpack_public_path__ + "static/media/project1.1a43924f.png";